import {CANNED_FETCH_REQUESTED} from "../../constants/ActionTypes";

export const fetchCannedResponses = () => ({type: CANNED_FETCH_REQUESTED});
